import { get, post } from '@/helpers/api'
import { reactive } from 'vue'

const tokens = reactive({
	tokensById: {},
})

const addToken = (token) => {
	tokens.tokensById[token.id] = token
}

export const getTokenHistory = async () => {
	tokens.tokensById = {}
	try {
		const { data } = await get('/api/v1/apitoken.list')
		data.apitokens.forEach(addToken)
		return { ok: true }
	} catch (e) {
		console.error(e)
		const { error } = (e.response && e.response.data) || {}
		return { ok: false, error }
	}
}

export const getScopes = async () => {
	try {
		const { data } = await get('/api/v1/apitoken.listscopes')
		return {
			ok: true,
			scopes: data.scopes.map((s) => ({ ...s, checked: false })),
		}
	} catch (e) {
		console.error(e)
		const { error } = (e.response && e.response.data) || {}
		return { ok: false, error }
	}
}

export const getTokensByValues = () => {
	return Object.values(tokens.tokensById)
}

export const activeTokens = () => {
	return Object.values(tokens.tokensById).filter((t) => t.active)
}

export const createToken = async ({ name, scopes }) => {
	try {
		const { data } = await post('/api/v1/apitoken.create', { name, scopes })
		addToken(data.apitoken)
		return { ok: true, token: data.apitoken.token }
	} catch (e) {
		console.error(e)
		const { error } = (e.response && e.response.data) || {}
		return { ok: false, error }
	}
}

export const revokeToken = async (id) => {
	try {
		const { data } = await post('/api/v1/apitoken.revoke', { apitoken_id: id })
		delete tokens.tokensById[id]
		return { ok: true }
	} catch (e) {
		console.error(e)
		const { error } = (e.response && e.response.data) || {}
		return { ok: false, error }
	}
}
